import { addChapterAction,
  deleteChapterAction,
  saveChapterAction,
  cancelChapterAction,
  retrieveChaptersAction,
  showChaptersFormAction,
  removeChapterAction,
  setLastChaptersViewAction,
  setDraftChaptersAction } from './actions';

const initialState = {
  chapters: {},
  isLoading: false,
  isError: false,
  shouldShowChaptersForm: false,
  newChapter: null,
  lastChaptersView: 'empty',
  draftChapters: {},
  draftChapterErrors: {}
};

const chaptersReducer = (state = initialState, action) => {
  switch (action.type) {
    case addChapterAction.toString(): {
      const { hoverTime } = action;
      const newChapter = { chapterTitle: '', chapterStartTimeSeconds: hoverTime ?? '' };
      return {
        ...state,
        newChapter
      };
    }

    case cancelChapterAction.toString(): {
      const { recordingId } = action;
      const existingChapters = state.chapters[recordingId] || [];
      const newChapters = existingChapters.map((chapter) => ({ ...chapter }));
      return {
        ...state,
        draftChapters: {
          ...state.draftChapters,
          [recordingId]: newChapters
        },
        draftChapterErrors: {
          ...state.draftChapterErrors,
          [recordingId]: {}
        },
        newChapter: null,
        shouldShowChaptersForm: false
      };
    }

    case removeChapterAction.toString(): {
      const { recordingId, index } = action;
      const existingChapters = state.chapters[recordingId] || [];
      existingChapters.splice(index, 1);
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [recordingId]: [...existingChapters]
        }
      };
    }

    case showChaptersFormAction.toString(): {
      const { shouldShowChaptersForm } = action;
      return {
        ...state,
        shouldShowChaptersForm
      };
    }

    case retrieveChaptersAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case retrieveChaptersAction.complete.toString(): {
      const fetchedChapters = action.payload.newChapter;
      const newChapters = {
        ...state.chapters,
        ...fetchedChapters
      };
      const newDraftChapters = {
        ...state.draftChapters,
        ...action.payload.draftChapter
      };
      return {
        ...state,
        isLoading: false,
        chapters: newChapters,
        draftChapters: newDraftChapters,
        draftChapterErrors: {}
      };
    }

    case retrieveChaptersAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    case saveChapterAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case saveChapterAction.complete.toString(): {
      const newChapters = action.payload.newChapter;
      const draftChapters = action.payload.draftChapter;
      return {
        ...state,
        isLoading: false,
        chapters: {
          ...state.chapters,
          ...newChapters
        },
        draftChapters: {
          ...state.draftChapters,
          ...draftChapters
        },
        draftChapterErrors: {},
        shouldShowChaptersForm: false
      };
    }

    case saveChapterAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    case deleteChapterAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case deleteChapterAction.complete.toString(): {
      const { deletedChapterId, recordingId } = action.payload;
      return {
        ...state,
        isLoading: false,
        draftChapters: {
          ...state.draftChapters,
          [recordingId]: state.draftChapters[recordingId].filter((chapter) => chapter.chapterId !== deletedChapterId)
        }
      };
    }

    case deleteChapterAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    case setLastChaptersViewAction.toString(): {
      const { view } = action;
      return {
        ...state,
        lastChaptersView: view
      };
    }

    case setDraftChaptersAction.toString(): {
      const { recordingId, draftChapters, draftChapterErrors } = action;
      return {
        ...state,
        draftChapters: {
          ...state.draftChapters,
          [recordingId]: draftChapters
        },
        draftChapterErrors: {
          ...state.draftChapterErrors,
          [recordingId]: draftChapterErrors || {}
        }
      };
    }

    default:
      return state;
  }
};

export default chaptersReducer;
